export default __webpack_public_path__ + "static/media/A1_1.8853be5b.png";